import React, { useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  stashPendingGoogleOAuth,
  stashPendingGoogleOAuthError,
} from "../Utils/pendingGoogleOAuth";
import { getGoogleOAuthRedirectUri } from "../Utils/googleAuth";

const GOOGLE_OAUTH_READY = "google-oauth-ready";

/**
 * Captures the Google OAuth redirect and sends the user to the app immediately.
 * Sign-in completes in the background (AuthProvider + corner loader).
 */
const OAuthCallback = () => {
  const navigate = useNavigate();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const oauthError = params.get("error");

    if (oauthError) {
      stashPendingGoogleOAuthError(oauthError);
    } else if (code) {
      stashPendingGoogleOAuth(code, getGoogleOAuthRedirectUri());
    } else {
      stashPendingGoogleOAuthError("No authorization code received from Google.");
    }

    window.dispatchEvent(new Event(GOOGLE_OAUTH_READY));
    navigate("/calendar", { replace: true });
  }, [navigate]);

  return null;
};

export { GOOGLE_OAUTH_READY };
export default OAuthCallback;
